<template>
  <v-card flat>
    <v-data-table fixed-header  height="55vh"
      :headers="headers"
      :items="getinformation"
      :search="search"
      item-key="id"
      class="elevation-1"
    >
      <template v-slot:item.id_type="{ item }">
        <span>{{ item.id_type ? item.id_type.value : null }}</span>
      </template>
      <template v-slot:item.occupation="{ item }">
        <span>{{ item.occupation ? item.occupation.value : null }}</span>
      </template>
      <template v-slot:item.nature_of_business="{ item }">
        <span>{{ item.nature_of_business ? item.nature_of_business.value : null }}</span>
      </template>
      <template v-slot:item.nationality="{ item }">
        <span>{{
          item.nationality ? item.nationality.nationality : null
        }}</span>
      </template>
      <template v-slot:item.id_first_page="{ item }">
        <v-avatar
          v-if="item.id_first_page"
          size="36px"
          @click="handleImageViewer(item.id_first_page)"
        >
          <img
            v-if="item.id_first_page"
            alt="Avatar"
            :src="item.id_first_page"
          />
          <v-icon v-else>mdi-user</v-icon>
        </v-avatar>
        <v-avatar v-else color="gray" size="24px">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <img
                v-bind="attrs"
                v-on="on"
                alt="Avatar"
                :src="'https://cdn2.iconfinder.com/data/icons/documents-and-files-v-2/100/doc-03-512.png'"
              />
            </template>
            <span>{{ $t("no_image") }}</span>
          </v-tooltip>
        </v-avatar>
      </template>
      <template v-slot:item.id_last_page="{ item }">
        <v-avatar
          v-if="item.id_last_page"
          size="36px"
          @click="handleImageViewer(item.id_last_page)"
        >
          <img v-if="item.id_last_page" alt="Avatar" :src="item.id_last_page" />
          <v-icon v-else>mdi-user</v-icon>
        </v-avatar>
        <v-avatar v-else color="gray" size="24px">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <img
                v-bind="attrs"
                v-on="on"
                alt="Avatar"
                :src="'https://cdn2.iconfinder.com/data/icons/documents-and-files-v-2/100/doc-03-512.png'"
              />
            </template>
            <span>{{ $t("no_image") }}</span>
          </v-tooltip>
        </v-avatar>
      </template>

      <template v-slot:top>
        <v-toolbar flat>
          <v-dialog v-model="dialog" max-width="700px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                small
                dark
                class=""
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark left>mdi-account-plus </v-icon>
                {{ $t("add_personal") }}
              </v-btn>
            </template>

            <v-card>
              <v-toolbar color="secondary" dark flat dense>
                <span class="subtitleFontsize">{{ formTitle }}</span>
                <v-spacer></v-spacer>
              </v-toolbar>

              <v-divider class="p-0 m-0"></v-divider>
              <v-card-text>
                <v-form v-model="valid" ref="busApplicant">
                  <v-row>
                    <!-- <v-col
                      cols="12"
                      md="6"
                      class="d-flex pt-0"
                      v-for="(users, index) in Entitycheckbox"
                      :key="index"
                    >
                      <v-checkbox
                        v-model="editedItem.applicant_type"
                        :disabled="editedItem.biz_user_id ? true : false"
                        :error-messages="applicantErrors"
                        @input="$v.editedItem.applicant_type.$touch()"
                        :label="users.name"
                        :value="users.name"
                        hide-details
                      ></v-checkbox>
                    </v-col> -->

                    <v-col class="pt-4" cols="12" md="6">
                      <label class="ma-0 pa-0">
                        {{ $t("user_type") }}
                        <span style="color: #f00">*</span></label
                      >
                      <v-autocomplete
                        :placeholder="$t('user_type_placeholder')"
                        :items="Entitycheckbox"
                        :error-messages="applicantErrors"
                        @input="$v.editedItem.applicant_type.$touch()"
                        v-model="editedItem.applicant_type"
                        dense
                        outlined
                      ></v-autocomplete>
                    </v-col>

                    <v-col class="pt-4" cols="12" md="6">
                      <label class="ma-0 pa-0"
                        >{{ $t("fullName")
                        }}<span
                          v-if="validationFields.includes('Full Name')"
                          style="color: #f00"
                          >*</span
                        ></label
                      >
                      <v-text-field
                        v-model="editedItem.full_name"
                        :error-messages="fnameErrors"
                        @input="$v.editedItem.full_name.$touch()"
                        dense
                        :placeholder="$t('fullName')"
                        outlined
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col class="pt-0" cols="12" md="6">
                      <label class="ma-0 pa-0">{{ $t("Gender") }}</label>
                      <v-autocomplete
                        :placeholder="$t('gender_placeholder')"
                        :items="genderOptions"
                        v-model="editedItem.gender"
                        dense
                        outlined
                      ></v-autocomplete>
                    </v-col>

                    <v-col class="pt-0" cols="12" md="6">
                      <label class="ma-0 pa-0"
                        >{{ $t("date_of_birth_business")
                        }}<span
                          v-if="validationFields.includes('DOB')"
                          style="color: #f00"
                          >*</span
                        ></label
                      >

                      <v-menu
                        ref="dobmenu"
                        v-model="dobmenu"
                        :close-on-content-click="false"
                        lazy
                        transition="scale-transition"
                        :offset-x="true"
                        full-width
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="editedItem.dob"
                            persistent-hint
                            clearable
                            v-on="on"
                            type="date"
                            dense
                            :error-messages="DOBerrors"
                            @input="$v.editedItem.dob.$touch()"
                            @change="ValidateAge"
                            :min="minDate"
                            :max="maxDate"
                            outlined
                          >
                          </v-text-field>
                        </template>
                      </v-menu>
                    </v-col>

                    <v-col class="pt-0" cols="12" md="6">
                      <label class="ma-0 pa-0">{{
                        $t("country_of_birth_business")
                      }}</label>
                      <v-autocomplete
                        :placeholder="$t('country_of_birth_placeholder')"
                        :items="country_options"
                        item-text="name"
                        item-value="id"
                        v-model="editedItem.country_code"
                        outlined
                        required
                        dense
                      ></v-autocomplete>
                    </v-col>

                    <v-col class="pt-0" cols="12" md="6">
                      <label class="ma-0 pa-0"
                        >{{ $t("Nationality")
                        }}<span
                          v-if="validationFields.includes('Nationality')"
                          style="color: #f00"
                          >*</span
                        ></label
                      >
                      <v-autocomplete
                        :placeholder="$t('nationality_placeholder')"
                        dense
                        v-model="editedItem.nationality_code"
                        :items="nationality_options"
                        item-text="name"
                        item-value="id"
                        :error-messages="nationalityErrors"
                        @input="$v.editedItem.nationality_code.$touch()"
                        outlined
                      ></v-autocomplete>
                    </v-col>

                    <v-col class="pt-0" cols="12" md="6">
                      <label class="ma-0 pa-0"
                        >{{ $t("Occupation")
                        }}<span
                          v-if="validationFields.includes('Designation')"
                          style="color: #f00"
                          >*</span
                        ></label
                      >
                      <v-autocomplete
                        v-model="editedItem.occupation_code"
                        :items="occupation_options"
                        item-text="name"
                        item-value="id"
                        :error-messages="designationErrors"
                        @input="$v.editedItem.occupation_code.$touch()"
                        :placeholder="$t('occupation_placeholder')"
                        dense
                        outlined
                        required
                      ></v-autocomplete>
                    </v-col>

                    <v-col class="pt-0" cols="12" md="6">
                      <label class="ma-0 pa-0"
                        >{{ $t("emailAddress")
                        }}<span style="color: #f00">*</span></label
                      >
                      <v-text-field
                        v-model="editedItem.email_id"
                        :error-messages="emailErrors"
                        @input="$v.editedItem.email_id.$touch()"
                        :placeholder="$t('email_placeholder')"
                        dense
                        outlined
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col class="pt-0" cols="12" md="6">
                      <label class="ma-0 pa-0">{{ $t("phoneNumber") }}</label>
                      <vue-phone-number-input
                        default-country-code="MY"
                        @update="onChangeNumber"
                        :error="!isValidNumber"
                        v-model="editedItem.phone_number"
                        class=""
                        required
                      />
                      <!-- <span style="color: #ff5252; font-size: 12px">{{
                          contactNoErrors[0]
                        }}</span> -->
                    </v-col>
                    <v-col
                      class="pt-0"
                      cols="12"
                      md="6"
                      v-if="validationFields.includes('No of Shares')"
                    >
                      <label class="ma-0 pa-0"
                        >{{ $t("share_holder_percentage")
                        }}<span style="color: #f00">*</span></label
                      >
                      <v-text-field
                        :placeholder="$t('share_holder_percentage')"
                        v-model="editedItem.no_of_shares"
                        suffix="%"
                        type="number"
                        :rules="validations.sharesRules"
                        outlined
                        required
                        hide-spin-buttons
                        dense
                      ></v-text-field>
                    </v-col>
                    <v-col class="pt-0" cols="12" md="6">
                      <label
                        class="ma-0 pa-0"
                        v-if="validationFields.includes('ID Number')"
                        >{{ $t("idType")
                        }}<span style="color: #f00">*</span></label
                      >
                      <v-select
                        v-if="validationFields.includes('ID Number')"
                        v-model="editedItem.id_type_code"
                        :menu-props="{ bottom: true, offsetY: true }"
                        :rules="validations.id_proofrules"
                        :items="idtypes_val"
                        item-text="name"
                        item-value="id"
                        outlined
                        required
                        :placeholder="$t('idtype_select_placeholder')"
                        dense
                      ></v-select>
                      <!-- <v-select 
                    v-else
                    v-model="id_type_back"
                    :menu-props="{ bottom: true, offsetY: true }"
                    :rules="validations.id_proofrules"
                    :items="idtypes_val"
                    item-text="name"
                    item-value="id"
                    :disabled="disableValues || disableBystatus"
                    outlined
                    required
                    :placeholder="$t('idtype_select_placeholder')"
                    dense
                  ></v-select> -->
                    </v-col>
                    <!-- <v-col class="pt-0" cols="12" md="6" v-if="validationFields.includes('ID Number')">
                          <label class="ma-0 pa-0">{{ $t("idType")
                          }}<span style="color: #f00">*</span></label>
                          <v-select  item-text="name" item-value="id" v-model="editedItem.id_type_code"
                            :menu-props="{ bottom: true, offsetY: true }" :rules="validations.id_proofrules"
                            :items="idtypes" outlined required :placeholder="$t('idtype_select_placeholder')"
                            dense></v-select>
  
                        </v-col> -->
                    <v-col
                      class="pt-0"
                      cols="12"
                      md="6"
                      v-if="
                        !isMykad &&
                        editedItem.id_type_code != 'MyPR' &&
                        !kycStatus
                      "
                    >
                      <label
                        class="ma-0 pa-0"
                        v-if="validationFields.includes('ID Number')"
                        >{{ $t("isuueDate")
                        }}<span style="color: #f00">*</span></label
                      >
                      <v-text-field
                        v-model="editedItem.id_issue_date"
                        v-if="validationFields.includes('ID Number')"
                        :rules="validations.issuedaterules"
                        dense
                        required
                        outlined
                        type="date"
                        :max="currentDate"
                      />
                    </v-col>
                    <v-col class="pt-0" cols="12" md="6">
                      <label
                        class="ma-0 pa-0"
                        v-if="validationFields.includes('ID Number')"
                        >{{ $t("Location")
                        }}<span
                          v-if="editedItem.id_type_code === 'Passport'"
                          style="color: #f00"
                          >*</span
                        ></label
                      >
                      <v-autocomplete
                        v-if="validationFields.includes('ID Number')"
                        v-model="editedItem.id_issue_country"
                        item-text="name"
                        item-value="id"
                        :items="country_options"
                        :rules="validations.issue_locationRules"
                        :placeholder="$t('Location')"
                        dense
                        outlined
                        required
                        :min="currentDate"
                      />
                    </v-col>

                    <v-col
                      class="pt-0"
                      cols="12"
                      md="6"
                      v-if="
                        !isMykad &&
                        editedItem.id_type_code != 'MyPR' &&
                        !kycStatus
                      "
                    >
                      <label
                        class="ma-0 pa-0"
                        v-if="validationFields.includes('ID Number')"
                        >{{ $t("expiryDate")
                        }}<span style="color: #f00">*</span></label
                      >
                      <v-text-field
                        v-model="editedItem.id_expiry_date"
                        v-if="validationFields.includes('ID Number')"
                        :rules="validations.expDateRules"
                        dense
                        outlined
                        required
                        type="date"
                        :min="currentDate"
                      />
                    </v-col>

                    <v-col
                      class="pt-0"
                      cols="12"
                      md="6"
                      v-if="validationFields.includes('ID Number')"
                    >
                      <label class="ma-0 pa-0"
                        >{{ $t("idNumber")
                        }}<span style="color: #f00">*</span></label
                      >
                      <v-text-field
                        v-model="editedItem.id_number"
                        :rules="validations.id_numberRules"
                        :placeholder="$t('id_number_placeholder')"
                        outlined
                        required
                        dense
                      ></v-text-field>
                    </v-col>

                    <v-col
                      class="pt-0"
                      cols="12"
                      md="6"
                      v-if="validationFields.includes('ID Number')"
                    >
                      <label class="ma-0 pa-0"
                        >{{ $t("IDFirstPage")
                        }}<span style="color: #f00">*</span></label
                      >
                      <v-file-input
                        v-model="editedItem.ID_First_Page"
                        :rules="validations.firstpage_rules"
                        dense
                        accept="image/png, image/jpeg, image/bmp, image/bmp"
                        :placeholder="$t('idtype_first_page_placeholder')"
                        outlined
                        ref="idfirstfile"
                        required
                        prepend-icon=""
                      >
                        <template v-slot:append>
                          <v-icon
                            aria-hidden="false"
                            class="color-primary"
                            @click="openIdfirst"
                          >
                            mdi-cloud-upload
                          </v-icon>
                        </template>

                        <template v-slot:append-outer>
                          <v-img
                            v-if="frontPageUrl && editedItem.ID_First_Page"
                            class="ml-1"
                            max-height="40"
                            max-width="50"
                            :src="frontPageUrl"
                            @click="handleImageViewer(frontPageUrl)"
                          />
                        </template>
                      </v-file-input>
                    </v-col>

                    <v-col
                      class="pt-0"
                      cols="12"
                      md="6"
                      v-if="validationFields.includes('ID Number')"
                    >
                      <label class="ma-0 pa-0">{{ $t("IDLastPage") }}</label>
                      <v-file-input
                        v-model="editedItem.ID_Last_Page"
                        dense
                        accept="image/png, image/jpeg, image/bmp, image/bmp"
                        :placeholder="$t('idtype_last_page_placeholder')"
                        outlined
                        ref="idlastfile"
                        required
                        prepend-icon=""
                      >
                        <template v-slot:append>
                          <v-icon
                            aria-hidden="false"
                            class="color-primary"
                            @click="openIdlast"
                          >
                            mdi-cloud-upload
                          </v-icon>
                        </template>

                        <template v-slot:append-outer>
                          <v-img
                            v-if="backPageUrl && editedItem.ID_Last_Page"
                            class="ml-1"
                            max-height="40"
                            max-width="50"
                            :src="backPageUrl"
                            @click="handleImageViewer(backPageUrl)"
                          />
                        </template>
                      </v-file-input>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
              <v-divider class="p-o m-0"></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  small
                  outlined
                  @click="close"
                  v-if="!editedItem.biz_user_id"
                >
                  {{ $t("cancel_label") }}
                </v-btn>
                <v-btn
                  color="primary"
                  small
                  @click="onClickNext()"
                  v-if="!editedItem.biz_user_id"
                  >{{ $t("save") }}</v-btn
                >
                <v-btn
                  color="primary"
                  outlined
                  small
                  @click="close"
                  v-if="editedItem.biz_user_id"
                >
                  {{ $t("cancel_label") }}
                </v-btn>
                <v-btn
                  color="primary"
                  small
                  @click="update()"
                  v-if="editedItem.biz_user_id"
                >
                  {{ $t("update_label") }}</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">
                {{ $t("want_to_delete_info") }}
              </v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete">
                  {{ $t("cancel_label") }}</v-btn
                >
                <v-btn color="blue darken-1" text @click="deleteItemConfirm">
                  {{ $t("okay") }}
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-menu :offset-x="true" open-on-hover v-if="is_shareholder">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                class="v-custome-btn ms-2"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon dark left>mdi-account-plus </v-icon
                >{{ $t("add_shareholder") }}
              </v-btn>
            </template>

            <v-list>
              <v-list-item link @click="showindDialog = true">
                <v-list-item-title
                  ><v-icon class="mb-1 me-2"> mdi-account-tie</v-icon>
                  {{ $t("individual") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item link @click="showBusDialog = true">
                <v-list-item-title
                  ><v-icon class="mb-1 me-2">mdi-briefcase-account</v-icon>
                  {{ $t("business") }}</v-list-item-title
                >
              </v-list-item>
            </v-list>
          </v-menu>
          <v-spacer></v-spacer>
          <v-col lg="6" sm="12" class="">
            <v-text-field
              v-model="search"
              append-icon="mdi-filter"
              :placeholder="$t('search_to_filter')"
              class=" "
              color="primary"
              outlined
              hide-details
              dense
            ></v-text-field>
          </v-col>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
        <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
      </template>
    </v-data-table>
    <v-dialog persistent v-model="showindDialog" width="700px">
      <v-col cols="12" class="p-0">
        <shareholder-ind
          @closeDialog="closeDialog"
          @getapplicant="getapplicant"
          :showindDialog="showindDialog"
        /> </v-col
    ></v-dialog>
    <v-dialog v-model="showBusDialog" width="700px">
      <v-col cols="12" class="p-0">
        <shareholder-bus
          @closeBusDialog="closeBusDialog"
          @getapplicant="getapplicant"
          :showBusDialog="showBusDialog"
        /> </v-col
    ></v-dialog>

    <image-viewer
      :showDialog="isImageViewer"
      :picture="{
        PicHeight: '435',
        PicWidth: 600,
        Pic: imageViewerUrl,
      }"
      @closeImageViewer="handleCloseImageViewer"
    ></image-viewer>
  </v-card>
</template>
<script>
import { mapGetters } from "vuex";
import { i18n as $ } from "@/locale/index";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import { email, required, requiredIf } from "vuelidate/lib/validators";
import { findDatePrevious } from "@/utils/helper";
import { alpha } from "@/utils/validate";
import { BusUserTypes } from "@/utils/BusDocuments";
import validatemixin from "@/mixins/Busvalidate.mixin";
// import imageViewer from "../../tools/imageViewer.vue";
import handleImageUpload from "@/mixins/compressImage.mixin";
import ShareholderInd from "./ShareholderInd.vue";
import ShareholderBus from "./ShareholderBus.vue";
import commonService from "@/services/CommonService/commonService.js";
import { isMykadIdType } from "@/utils/isMykadIdType.js";
import businessService from "@/services/BusinessService/businessService.js";
import alerts from "@/mixins/alerts";
export default {
  mixins: [validatemixin, handleImageUpload, alerts],
  data: () => ({
    id_type: "",
    dialog: false,
    showindDialog: false,
    showBusDialog: false,
    search: "",
    valid: true,
    currentDate: new Date().toJSON().split("T")[0],
    buscheckboxes: BusUserTypes(),
    Entitycheckbox: [],
    validationFields: [],
    backPageUrl: null,
    frontPageUrl: null,
    dialogDelete: false,
    dobmenu: false,
    kycStatus: null,
    disableBystatus: null,
    id_type_back: null,
    issue_location: null,
    maxDate: "",
    minDate: "",
    isDobError: false,
    expriydate: false,
    isValidNumber: false,
    country_options: [],
    relation_options: [],
    idtypes: [],
    idtypes_val: [],
    idtype_objs: [],
    nationality_options: [],
    occupation_options: [],
    occupation_objs: [],
    genderOptions: [
      { text: "Male", value: "M" },
      { text: "Female", value: "F" },
    ],
    isSubmitted: false,
    isUploading: false,
    countrySelected: {},
    headers: [
      {
        text: "ID",
        align: "start",
        sortable: false,
        value: "biz_user_id",
      },
      {
        text: "Name/Company",
        align: "start",
        sortable: false,
        value: "full_name",
      },
      { text: "ID type", value: "id_type", sortable: false },
      { text: "ID number", value: "id_number", sortable: false },
      { text: "Designation", value: "applicant_type", sortable: false },
      { text: "Nationality", value: "nationality", sortable: false },
      { text: "DOB/DOI", value: "dob", sortable: false },
      { text: "Email", value: "email_id", sortable: false },
      { text: "Contact Number", value: "phone_number", sortable: false },
      { text: "Employer Name", value: "employee_name", sortable: false },
      {
        text: "Shareholding (%)",
        value: "percentage_of_shares",
        sortable: false,
      },
      {
        text: "Nature of Business",
        value: "nature_of_business",
        sortable: false,
      },
      {
        text: "Occupation",
        value: "occupation",
        sortable: false,
      },
      { text: "First page", value: "id_first_page", sortable: false },
      { text: "Last page", value: "id_last_page", sortable: false },
    ],
    getinformation: [],
    editedIndex: -1,
    biz_user_id: "",
    imageViewerUrl: "",
    isImageViewer: false,
    userId: null,
    editedItem: {
      applicant_type: [],
      full_name: "",
      middle_name: "",
      last_name: "",
      gender: "",
      dob: null,
      email_id: "",
      phone_number: "",
      nationality_code: "",
      occupation_code: "",
      country_code: "",
      // applicant_country_code: "",
      id_type_code: null,
      id_number: null,
      ID_First_Page: null,
      ID_Last_Page: null,
      no_of_shares: null,
      id_issue_date: null,
      id_expiry_date: null,
      id_issue_country: "Malaysia",
      biz_user_id: null,
    },
    deleteId: "",
    defaultItem: {
      applicant_type: [],
      first_name: "",
      middle_name: "",
      last_name: "",
      gender: "",
      dob: null,
      email_id: "",
      phone_number: "",
      nationality_code: "",
      occupation_code: "",
      country_code: "",
      // applicant_country_code: "",
      id_type_code: null,
      id_number: null,
      ID_First_Page: null,
      ID_Last_Page: null,
      no_of_shares: null,
      id_issue_date: null,
      id_expiry_date: null,
      id_issue_country: "",
    },
    validations: {
      selfy_rules: [(v) => !!v || $.t("file_select_placeholder")],
      firstpage_rules: [(v) => !!v || $.t("file_select_placeholder")],
      issuedaterules: [(v) => !!v || $.t("issueDateMsg1")],
      issue_locationRules: [],
      expDateRules: [(v) => !!v || $.t("expiryDateMsg1")],
      id_proofrules: [(v) => !!v || $.t("idtypeMsg1")],
      id_numberRules: [(v) => !!v || $.t("idnumberMsg1")],
      interviewData: [(v) => !!v || $.t("interviewDate")],
      interviewTime: [(v) => !!v || $.t("interviewTime")],
      sharesRules: [
        (v) => !!v || $.t("no_ofshares"),
        (v) => (v > 25 && v < 100) || $.t("no_ofsharesmsg"),
      ],
    },
    is_shareholder: true,
  }),
  name: "BasicDetails",
  components: {
    VuePhoneNumberInput,
    // imageViewer,
    ShareholderInd,
    ShareholderBus,
  },
  props: {
    selctedEntity: {
      type: String,
    },
  },
  computed: {
    isMykad() {
      return isMykadIdType(this.editedItem.id_type_code, this.idtypes_val);
    },
    formTitle() {
      return this.editedIndex === -1 ? "Applicant Info" : "Edit Applicant Info";
    },
    ...mapGetters("Transactional", [
      "realtion_list",
      "nationality_list",
      "occupation_list",
    ]),
    ...mapGetters("Authentication", ["country_list"]),
    applicantErrors() {
      const errors = [];
      if (!this.$v.editedItem.applicant_type.$dirty) return errors;
      !this.$v.editedItem.applicant_type.required &&
        errors.push(this.$t("usertype_req"));
      return errors;
    },
    fnameErrors() {
      const errors = [];
      if (!this.$v.editedItem.full_name.$dirty) return errors;
      !this.$v.editedItem.full_name.required &&
        errors.push(this.$t("full_name"));
      !this.$v.editedItem.full_name.alpha &&
        errors.push(this.$t("invalid_full_name"));
      return errors;
    },

    designationErrors() {
      const errors = [];
      if (!this.$v.editedItem.occupation_code.$dirty) return errors;
      !this.$v.editedItem.occupation_code.required &&
        errors.push(this.$t("select_occupation"));
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.editedItem.email_id.$dirty) return errors;
      !this.$v.editedItem.email_id.required &&
        errors.push(this.$t("email_errors"));
      !this.$v.editedItem.email_id.email &&
        errors.push(this.$t("invalid_email"));
      return errors;
    },

    nationalityErrors() {
      const errors = [];
      if (!this.$v.editedItem.nationality_code.$dirty) return errors;
      !this.$v.editedItem.nationality_code.required &&
        errors.push(this.$t("nationality"));
      return errors;
    },

    DOBerrors() {
      const errors = [];
      if (!this.$v.editedItem.dob.$dirty) return errors;
      !this.$v.editedItem.dob.required && errors.push(this.$t("select_dob"));
      if (this.isDobError) {
        errors.push(this.$t("invalid_dob"));
      }
      return errors;
    },
  },

  watch: {
    isMykad(value) {
      if (value) {
        this.editedItem.id_issue_date = null;
        this.editedItem.id_expiry_date = null;
      }
    },
    "editedItem.applicant_type"(applicant_type) {
      console.log("applicant_type", applicant_type);
      this.validationFields = [...this.getRequired(applicant_type)];
      console.log("applicant_type:", this.getRequired(applicant_type));
    },
    selctedEntity: {
      handler(newval) {
        console.log("treatEntityName", newval);
        this.EntityName = newval;
        this.returnBusCheckbox(newval, this.buscheckboxes);
        console.log(" this.EntityName ", newval);
      },
    },
    "editedItem.id_type"(val) {
      this.idtype_objs.map((i) => {
        if (val === i.parameter_value) {
          this.id_type_code = i.parameter_code;
        }
      });
    },
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },

    id_type(val) {
      this.idtype_objs.map((i) => {
        if (val === i.value) {
          this.id_type_code = i.id;
        }
      });
      if (val == "MYKAD" || val == "MyPR") {
        this.editedItem.id_issue_country = "Malaysia";
        this.disableIssueLoc = true;
      } else {
        // this.user_details.issue_location = "";
        this.disableIssueLoc = false;
      }
      if (val === "Passport") {
        this.validations.issue_locationRules = [
          (v) => !!v || $.t("issue_location_placeholder"),
        ];
      } else {
        this.validations.issue_locationRules = [];
      }
    },

    "editedItem.issue_location"(val) {
      this.country_objs.map((i) => {
        if (val === i.name) {
          this.issue_location_code = i.iso3;
        }
      });
    },

    "editedItem.id_issue_date"(val) {
      if (!val < new Date().toJSON().split("T")[0]) {
        this.validations.issuedaterules.push($.t("issue_date_valid"));
      } else {
        this.validations.issuedaterules = [(v) => !!v || $.t("issueDateMsg1")];
      }
    },
    "editedItem.id_expiry_date"(val) {
      if (!val > new Date().toJSON().split("T")[0]) {
        this.validations.expDateRules.push($.t("expiry_date_issue_validate"));
      } else {
        this.validations.expDateRules = [(v) => !!v || $.t("expiryDateMsg1")];
      }
    },

    countrySelected(newVal) {
      console.log("Selected country", newVal);
      if (Object.keys(newVal).length > 0) {
        this.editedItem.country_code = newVal.name;
        this.editedItem.applicant_country_code = newVal.iso3;
      }
    },
  },

  created() {
    // this.initialize();
  },
  validations() {
    return {
      editedItem: {
        applicant_type: {
          required,
        },
        full_name: {
          required: requiredIf(function () {
            if (this.validationFields.includes("Full Name")) return true;
            else return false;
          }),
          alpha,
        },
        nationality_code: {
          required: requiredIf(function () {
            if (this.validationFields.includes("Nationality")) return true;
            else return false;
          }),
        },
        occupation_code: {
          required: requiredIf(function () {
            if (this.validationFields.includes("Designation")) return true;
            else return false;
          }),
        },
        email_id: {
          required,
          email,
        },

        dob: {
          required: requiredIf(function () {
            if (this.validationFields.includes("DOB")) return true;
            else return false;
          }),
        },
      },
    };
  },
  mounted() {
    this.returnBusCheckbox(this.selctedEntity, this.buscheckboxes);
    this.getOccupation();
    this.getNationalityList();
    this.getidtypes();
    if (this.$route.query.customer_id) {
      this.getapplicant();
    }

    this.maxDate = findDatePrevious(new Date(), 18);
    this.minDate = findDatePrevious(new Date(), 70);
  },

  methods: {
    closeDialog(val) {
      console.log(val);
      this.showindDialog = val;
    },
    closeBusDialog(val) {
      console.log(val);
      this.showBusDialog = val;
    },

    handleCloseImageViewer() {
      this.isImageViewer = !this.isImageViewer;
      this.imageViewerUrl = "";
    },
    handleImageViewer(url) {
      this.isImageViewer = !this.isImageViewer;
      this.imageViewerUrl = url;
    },

    async getapplicant() {
      this.isLoading = true;
      try {
        const responseData = await businessService.getAllApplicantsinfo({
          customer_id: this.$route.query.customer_id,
        });
        if (responseData && responseData.data.status_code == 200) {
          this.getinformation = responseData.data.data.reverse();
          this.isLoading = false;
        } else {
          this.isLoading = false;
          this.showAlertError(responseData.data.message);
        }
      } catch (error) {
        this.isLoading = false;
        this.showAlertError(
          "Error: Something went wrong please try again later."
        );
        console.warn("Error", error);
      }
    },

    returnBusCheckbox(val, documents) {
      console.log("doc val", val);
      console.log("doc", documents);
      for (let doc in documents) {
        console.log("doc in", doc);
        if (doc === val) {
          console.log("doc did", documents[doc]);
          this.Entitycheckbox = documents[doc].list;
          this.is_shareholder = documents[doc].is_shareholder;
        }
      }
    },

    async getOccupation() {
      try {
        const responseData = await commonService.getparameterdropdowns("OCC");
        if (responseData.data.status_code === 200) {
          this.occupation_options = responseData.data.data.map((i) => {
            this.occupation_objs.push(i);
            return {
              name: i.value,
              id: i.value_code,
            };
          });
        }

        console.log("Funds", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async fileUpload(fileObject, biz_user_id, doc_type) {
      this.loader = true;
      let compressdata = await this.handleImageUpload(fileObject);
      console.log(compressdata);
      let fileData = new FormData();
      fileData.append("document", compressdata);
      try {
        const responseData = await businessService.UploadApplicantFiles(fileData, {
          customer_id: this.$route.query.customer_id,
          biz_user_id: biz_user_id,
          doc_type: doc_type,
        });

        if (responseData && responseData.data.status_code == 200) {
          console.log("responseData", responseData);
          this.loader = false;
          this.getapplicant();
        } else {
          this.loader = false;
        }
      } catch (error) {
        this.loader = false;
        console.log(error);
      }
    },
    async getidtypes() {
      try {
        const responseData = await commonService.getparameterdropdowns("DOC");
        if (responseData.data.status_code === 200) {
          responseData.data.data.map((idtype) => {
            this.idtypes.push(idtype.value);
            this.idtypes_val.push({
              name: idtype.value,
              id: idtype.value_code,
            });
            this.idtype_objs.push(idtype);
          });
        }

        console.log("Funds", responseData);
      } catch (e) {
        console.error(e);
      }
    },

    open() {
      this.$refs.selfiefile.$el.querySelector("input").click();
    },
    openIdlast() {
      this.$refs.idlastfile.$el.querySelector("input").click();
    },
    openIdfirst() {
      this.$refs.idfirstfile.$el.querySelector("input").click();
    },
    ValidateAge(value) {
      if (!value) this.isDobError = false;
      else this.isDobError = !(value <= this.maxDate && value >= this.minDate);
    },
    onChangeNumber(e) {
      this.isValidNumber = e.isValid;
    },

    async getNationalityList() {
      try {
        const responseData = await commonService.getCountryBirthList();
        if (responseData.data.status_code === 200) {
          responseData.data.data.map((i) => {
            this.country_options.push({
              name: i.country_name,
              id: i.iso_alpha3,
            });
            this.nationality_options.push({
              name: i.nationality,
              id: i.iso_alpha3,
            });
          });
        }

        console.log("countrys", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    editItem(item) {
      this.editedIndex = this.getinformation.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.editedItem.applicant_type = item.type;
      console.log("image data", item.type);
      this.idtype_objs.map((ele) => {
        console.log("ele", ele);
        if (ele.value == item.id_type_code) {
          this.editedItem.id_type_code = ele.value_code;
        }
      });
      this.editedItem.ID_First_Page = item.first_page
        ? {
            name: item.first_page?.split("/").pop(),
            value: item.first_page,
          }
        : null;

      this.editedItem.ID_Last_Page = item.last_page
        ? {
            name: item.last_page?.split("/").pop(),
            value: item.last_page,
          }
        : null;
      this.backPageUrl = item.last_page ? item.last_page : null;
      this.frontPageUrl = item.first_page ? item.first_page : null;
      this.editedItem.occupation_code = item.occupation_code
        ? item.occupation_code
        : null;
      // this.getapplicant();
      this.dialog = true;
    },

    deleteItem(item) {
      this.dialogDelete = true;
      this.deleteId = item.biz_user_id;
    },

    async deleteItemConfirm() {
      this.loader = true;
      try {
        const responseData = await businessService.deleteApplicantInfo({
          biz_user_id: this.deleteId,
        });
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(responseData.data.message);
          this.getapplicant();
          this.loader = false;
        } else {
          this.loader = false;
          this.showAlertError(responseData.data.message);
        }
      } catch (error) {
        this.loader = false;
        this.showAlertError(
          "Error: Something went wrong please try again later."
        );
        console.warn("Error", error);
      }
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        // this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.deleteId = "";
      });
    },

    onClickNext() {
      console.log(`editedItem: ${JSON.stringify(this.editedItem)}`);
      this.$v.$touch();
      if (this.$v.$invalid && this.$refs.busApplicant.validate()) {
        return;
      }
      if (this.$refs.busApplicant.validate()) {
        this.save();
      }
    },

    onClickBack() {
      this.$emit("onClickBack");
    },

    async save() {
      this.loader = true;
      if (this.editedIndex > -1) {
        Object.assign(this.getinformation[this.editedIndex], this.editedItem);
      }
      try {
        const responseData = await businessService.addApplicantInfo(
          this.editedItem,
          {
            customer_id: this.$route.query.customer_id,
          }
        );

        if (
          responseData &&
          responseData.data &&
          responseData.data.success === true
        ) {
          this.userId = responseData.data.data[0].biz_user_id;
          console.log(" this.userId", this.userId);
          this.loader = false;
          console.log("ll", responseData);
          this.showAlertSuccess(responseData.data.message);
          this.fileUpload(
            this.editedItem.ID_First_Page,
            responseData.data.data[0].biz_user_id,
            "ID_First_Page"
          );
          this.fileUpload(
            this.editedItem.ID_Last_Page,
            responseData.data.data[0].biz_user_id,
            "ID_Last_Page"
          );
          this.getapplicant();
          this.close();
        } else {
          this.loader = false;
          this.showAlertError(`Creation Failed: ${responseData.data.message}`);
        }
      } catch (error) {
        this.loader = false;
        this.showAlertError(
          "Error: Something went wrong please try again later."
        );
      }
    },

    update() {
      this.$v.$touch();
      if (this.$v.$invalid && this.$refs.busApplicant.validate()) {
        return;
      }
      if (this.$refs.busApplicant.validate()) {
        this.updateData();
      }
    },

    async updateData() {
      this.loader = true;
      try {
        const responseData = await businessService.updateApplicantInfo(
          this.editedItem,
          {
            customer_id: this.$route.query.customer_id,
            biz_user_id: this.editedItem.biz_user_id,
          }
        );
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(responseData.data.message);
          this.fileUpload(
            this.editedItem.ID_First_Page,
            responseData.data.data[0].biz_user_id,
            "ID_First_Page"
          );
          this.fileUpload(
            this.editedItem.ID_Last_Page,
            responseData.data.data[0].biz_user_id,
            "ID_Last_Page"
          );

          this.getapplicant();
          this.close();
          this.loader = false;
        } else {
          this.loader = false;
          this.showAlertError(responseData.data.message);
        }
      } catch (error) {
        this.loader = false;
        this.showAlertError(
          "Error: Something went wrong please try again later."
        );
        console.warn("Error", error);
      }
    },
  },
};
</script>
<style>
.v-input .v-label {
  margin-bottom: 0px !important;
}
</style>
